module.exports = __webpack_public_path__ + "img/pattern-2.e37dc9fd.svg";